/**
 * @generated SignedSource<<045d9efba8924a6caa25fb28726bfa49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type accountCreateStripeConnectDashboardLinkMutation$variables = {};
export type accountCreateStripeConnectDashboardLinkMutation$data = {
  readonly createStripeConnectDashboardLink: string | null;
};
export type accountCreateStripeConnectDashboardLinkMutation = {
  variables: accountCreateStripeConnectDashboardLinkMutation$variables;
  response: accountCreateStripeConnectDashboardLinkMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "createStripeConnectDashboardLink",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountCreateStripeConnectDashboardLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accountCreateStripeConnectDashboardLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "80fd32d52d381b1e95f145545e32a6fd",
    "id": null,
    "metadata": {},
    "name": "accountCreateStripeConnectDashboardLinkMutation",
    "operationKind": "mutation",
    "text": "mutation accountCreateStripeConnectDashboardLinkMutation {\n  createStripeConnectDashboardLink\n}\n"
  }
};
})();

(node as any).hash = "2f009b5a6eab6a75fc3c0234cac4ec9d";

export default node;
